import { render, staticRenderFns } from "./qualityReport.vue?vue&type=template&id=096f547c&scoped=true&"
import script from "./qualityReport.vue?vue&type=script&lang=js&"
export * from "./qualityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f547c",
  null
  
)

export default component.exports